
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";

@Component({
  components: { Dropdown }
})
export default class Tab extends Vue {
  @Prop()
  value!: string;

  @Prop()
  id!: string;

  get classList() {
    return {
      "breakdance-tab": true,
      [`breakdance-tab--id-${this.id}`]: true,
      "breakdance-tab--active": this.value === this.id
    };
  }

  get hasContextMenuSlot() {
    return !!this.$slots.contextmenu;
  }

  get hasIconSlot() {
    return !!this.$slots.icon;
  }

  contextMenu = false;
  contextMenuX = 0;
  contextMenuY = 0;

  openContextMenu(e: MouseEvent) {
    if (!this.hasContextMenuSlot) {
      return;
    }

    e.preventDefault();

    this.contextMenu = false;
    this.contextMenuX = e.clientX;
    this.contextMenuY = e.clientY;

    this.$nextTick(() => {
      this.contextMenu = true;
    });
  }
}
